import { render, staticRenderFns } from "./ShowOrderState.vue?vue&type=template&id=a0f1313a&scoped=true&"
import script from "./ShowOrderState.vue?vue&type=script&lang=js&"
export * from "./ShowOrderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f1313a",
  null
  
)

export default component.exports